import { P } from '@ahmdigital/ui';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';
import React from 'react';

import {
  CtaWrapper,
  DescriptionWrapper,
  ImageWrapper,
  InformationWrapper,
  StyledClickable,
  StyledImage,
  TileWrapper,
  Title,
} from './styles';
import { ImageType } from '../../types/image';
import { PortableTextType } from '../../types/sanityInternal';
import { UrlObject } from '../../types/__codegen__/sanity/graphql';

type Props = {
  image?: ImageType | null;
  subtitle?: string | PortableTextType[];
  title?: string | PortableTextType[];
  urlObject?: UrlObject;
};

const InformationTile = ({ image, subtitle, title, urlObject }: Props) => {
  const imageUrl = image?.src;
  const description = portableTextToPlain(subtitle as PortableTextType[]);

  return (
    <TileWrapper>
      <InformationWrapper>
        <Title variant={['bold', 'marginBottomSpacer11']}>{title}</Title>
        <DescriptionWrapper>
          <P>{description}</P>
        </DescriptionWrapper>

        {urlObject && (
          <CtaWrapper>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
            <StyledClickable to={urlObject?.url}>{urlObject?.name}</StyledClickable>
          </CtaWrapper>
        )}
      </InformationWrapper>
      {image && (
        <ImageWrapper>
          <StyledImage alt={image?.alt} src={imageUrl} />
        </ImageWrapper>
      )}
    </TileWrapper>
  );
};

export default InformationTile;
